'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = locationChangeListener;
function locationChangeListener() {
  history.pushState = function (f) {
    return function pushState() {
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new Event('pushState'));
      window.dispatchEvent(new Event('locationChange'));
      return ret;
    };
  }(history.pushState);

  history.replaceState = function (f) {
    return function replaceState() {
      var ret = f.apply(this, arguments);
      window.dispatchEvent(new Event('replaceState'));
      window.dispatchEvent(new Event('locationChange'));
      return ret;
    };
  }(history.replaceState);

  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event('locationChange'));
  });
}
module.exports = exports['default'];